import { requests } from '../../../utils';
import { IMPERSONATE_URL } from '../../../utils/endpoints';

export const ImpersonateService = {
    impersonateUser: (userId?: string, token?: string) =>
        requests.post(`${IMPERSONATE_URL}/${token}/${userId}/impersonate`, {}),
};
